var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoveIsi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.avocado_zestien{fill:#E598A3;}\r\n\t.avocado_vijftien{fill:#D36781;}\r\n\t.avocado_een{fill:#231F20;}\r\n\t.st0{fill:#EAD13F;}\r\n\t.st1{fill:#CC4121;}\r\n\t.st2{fill:#FFFAEE;}\r\n\t.st3{fill:#E0A838;}\r\n\t.st4{fill:#D1712A;}\r\n\t.st5{fill:#A3AEB5;}\r\n\t.st6{fill:#788287;}\r\n\t.st7{fill:#C3CC6A;}\r\n\t.st8{fill:#6F9B45;}\r\n\t.st9{fill:#248EBC;}\r\n\t.st10{fill:#8D3E93;}\r\n\t.st11{fill:#3D3935;}\r\n\t.st12{fill:#716558;}\r\n\t.st13{fill:#AF9480;}\r\n\t.st14{fill:#DBD2C1;}\r\n\t.st15{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "avocado_vijftien",
    d: "M16,27.437C17.777,26.495,29.5,19.975,29.5,12c0-4.136-3.364-7.5-7.5-7.5 c-2.147,0-4.197,0.93-5.625,2.551L16,7.478l-0.375-0.426C14.197,5.43,12.147,4.5,10,4.5c-4.136,0-7.5,3.364-7.5,7.5 C2.5,19.975,14.223,26.495,16,27.437z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "avocado_een",
    d: "M22,4c-2.393,0-4.534,1.056-6,2.721C14.534,5.056,12.393,4,10,4c-4.418,0-8,3.582-8,8 c0,9,14,16,14,16s14-7,14-16C30,7.582,26.418,4,22,4z M16,26.869C13.664,25.601,3,19.406,3,12c0-3.86,3.14-7,7-7 c2.003,0,3.917,0.868,5.25,2.382L16,8.234l0.75-0.852C18.083,5.868,19.997,5,22,5c3.86,0,7,3.14,7,7 C29,19.406,18.336,25.601,16,26.869z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "avocado_zestien",
    cx: 8,
    cy: 10,
    r: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIsi);
export default __webpack_public_path__ + "static/media/love-isi.48aa59bc02bb1482e62934dfef727533.svg";
export { ForwardRef as ReactComponent };